import { BaseReactiveClass } from '@/classes/BaseReactiveClass';
// eslint-disable-next-line import/no-cycle
import { MarketOfferClass } from '@/classes/MarketOfferClass';
import { httpClientMarket, httpClientInvestment } from 'Api/microservice-http-clients';
import INVESTMENT_CONST from 'Const/investment.json';
import { getUrlParamsByObject } from 'Utils/url';

const { SM_STATUS } = INVESTMENT_CONST;

export class MarketOfferBidClass extends BaseReactiveClass {
  get offer() {
    return this._offer;
  }

  set offer(offerData) {
    this.$set('_offer', new MarketOfferClass(offerData));
  }

  get farm() {
    return this.offer?.farm;
  }

  get isStatusActive() {
    return this.status === SM_STATUS.ACTIVE;
  }

  get isStatusAccepted() {
    return this.status === SM_STATUS.ACCEPTED;
  }

  get isStatusPending() {
    return this.status === SM_STATUS.PENDING;
  }

  get isStatusConfirmed() {
    return this.status === SM_STATUS.CONFIRMED;
  }

  get isAccepted() {
    return this.isStatusAccepted || this.isStatusConfirmed;
  }

  get isOwn() {
    return Boolean(this.your);
  }

  get isNewDocument() {
    return this.offer?.farm?.isNewDocument;
  }

  get isNewFinancialStatementDocument() {
    return this.offer?.farm?.isNewFinancialStatementDocument;
  }

  cancelBid() {
    return httpClientMarket.delete(`/bid/${this.id}`);
  }

  /**
   * Get sign url and bid id
   * @returns {Promise<{id, url}>}
   */
  async getDocuSignJoinderAgreementUrl() {
    const { data } = await httpClientMarket.get(`/bid/${this.id}/signing/joinder-agreement?resign=false`);
    return data?.url;
  }

  async getDocusignUrl(docName, id, resign = false, ssn) {
    if (!docName || !id) return null;
    const urlParams = getUrlParamsByObject({ resign, ssn: ssn || undefined });
    const { data } = await httpClientInvestment.get(`${id}/signing/${docName}${urlParams}`);
    return data?.url;
  }
}
